import React from 'react';
import type { BestAvailableOrderProps, OrderProps } from "../../types"
import { Icons } from '../../Components';
import OrderGradeBar from './OrderGradeBar';
import { MarketComponentHelpers } from '../api';
import moment from 'moment-mini';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type BestAvailableOrderCardProps = {
    player_id?:string,
    order:BestAvailableOrderProps,
    show_grade?:boolean,
    float?:boolean,
    style?:any
    onShareOrder?:(order:BestAvailableOrderProps) => void,
    onBuyNow?: (order:OrderProps) => void,
    onCancelOrder?:(order_id:string) => void
}

const BestAvailableOrderCard = ({ order, player_id, float, style, show_grade, onBuyNow, onShareOrder, onCancelOrder }:BestAvailableOrderCardProps) => {
    const Colors = useColors()
    const handleBuyNow = () => {
        if(!onBuyNow){ return }
        onBuyNow({
            ...order, 
            be_type:'market',
            market_type: 'FOR_MONEY',
            collar_pct: 0,
            status: 'approved',
            available_for_parlays: false,
            commission_pct: 0,
            resolution_status: 'inprogress',
            position_ids: [],
            positions: [],
            side_type: order.side_type as 'team'|'athlete',
            event_type: order.event_type as 'team'|'tournament'|'match',
            open_amt: Math.floor(order.open_amt * 100) / 100,
            influencer_id:undefined,
            influence_type: undefined,
            draft_liquidity: Math.floor(order.open_amt * 100)/100,
            tip_pct:undefined,
            tip_type:undefined,
            expire_datetime: moment().add(1, 'minutes'), 
            order_type: 'limit', 
            buy_sell_ind: 'buy' 
           })
    }

    return (
        <View float={float} style={[style]}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:14, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Text style={{ flexGrow:1 }} theme='h1' size={14} textAlign='center'>{order.title}</Text>
            </View>
            <View type='body' style={{ flexGrow:1, padding:15 }}>
                <Text style={{ margin:3 }} size={12} theme='h1' textAlign='center'>${order.open_amt.toFixed(2)} to win ${order.potential_winnings.toFixed(2)}</Text>
                <Text style={{ margin:3 }} size={12} theme='h2' textAlign='center'>PRICE</Text>
                <Text style={{ margin:3 }} size={12} theme='h1' textAlign='center'>{(order.probability * 100).toFixed(2)}% ({MarketComponentHelpers.getOddsLabel(order.odds)})</Text>
                
                <View style={{ padding:5 }}>
                    <OrderGradeBar mask={show_grade ? false : true} grade={order.grade} view_type='card' />
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                {onShareOrder ?
                <Button 
                    type='close'
                    style={{ marginRight:10, alignItems:'center' }}
                    onPress={() => onShareOrder(order)}>
                    <Icons.ShareIcon color={Colors.text.h1} size={14}/>
                </Button>
                :<></>}
                {player_id == order.player_id && onCancelOrder ?
                <Button 
                    type='error'
                    title='CANCEL'
                    style={{ flex:1 }}
                    onPress={() => onCancelOrder(order.order_id)}>
                </Button>
                :
                <Button 
                    type='success'
                    title='BUY'
                    style={{ flex:1 }}
                    onPress={() => handleBuyNow()}>
                    
                </Button>
                }
            </View>
        </View>
    )
}


export default BestAvailableOrderCard